import React from "react";
import type { Order } from "@/types";
import { useI18n } from "@/i18n";
import { haptic, openExternalLink } from "@/lib/telegram";

/** Gift order: the buyer sends the claim link to the recipient via Telegram. */
export function GiftShare({ order }: { order: Order }) {
  const { t } = useI18n();
  let link = order.giftLink ?? null;
  if (!link) {
    try {
      link = sessionStorage.getItem(`kms.gift.${order.id}`);
    } catch {
      link = null;
    }
  }
  if (!order.isGift) return null;
  if (order.giftClaimedAt) {
    return (
      <div className="arrive-card">
        <strong>◆ {t("gift.recipientChose")}</strong>
        <span>{order.giftRecipientName ? t("gift.recipientName", { name: order.giftRecipientName }) : t("gift.claimedBuyer")}</span>
      </div>
    );
  }
  return (
    <div className="arrive-card">
      <strong>🎁 {t("gift.sendTitle")}</strong>
      <span>{order.paymentStatus === "paid" ? t("gift.sendText") : t("gift.sendAfterPay")}</span>
      {link && order.paymentStatus === "paid" && (
        <button
          className="btn btn--primary"
          onClick={() => {
            haptic("light");
            openExternalLink(`https://t.me/share/url?url=${encodeURIComponent(link!)}&text=${encodeURIComponent(t("gift.shareText"))}`);
          }}
        >
          {t("gift.sendButton")}
        </button>
      )}
    </div>
  );
}
